module.exports = __webpack_public_path__ + "static/media/topDownShooter.89e5a2bd.webp";